import { UI2ColorName } from 'shared-libs/components/ui2/theme/color-names'

/**
 * DW/MW half of the shared color vocabulary: turns a registry ramp position into a
 * `var()` reference so the hex stays owned by SCSS (`$ui2-color-scale`). Emitted on `:root`,
 * not behind a mixin — a missing include would resolve the value to nothing with no error.
 */
export function resolveUI2Color(name: UI2ColorName): string {
  return `var(--ui2-color-${name})`
}
